import useSWR from "swr";
import Layout from "../../../components/custom/Layout";
import { customFetcher, getTsDate, notify } from "../../../utils";
import { IssueReport, IssueReportStatus, IssueReportTypes } from "../../../globals/interfaces";
import VirtualTable from "../../../components/custom/VirtualTable";
import { useState } from "react";
import useModal from "../../../customHooks/useModal";
import DetailsModal from "./DetailsModal";
import apiClient from "../../../apiClient";
import useUser from "../../../customHooks/useUser";
import { Nav } from "reactstrap";
import CustomNavItem from "../../../components/custom/CustomNavItem";
import { TabContent } from "reactstrap";
import CustomTabPane from "../../../components/custom/CustomTabPane";
import DataTable from "../../../components/import/Transfers/Buildup/DataTable";

export type UpdateIssue = (status: IssueReportStatus, note: string, notifyUser: boolean) => Promise<void>;
export type AssignIssue = (assignedTo: string) => Promise<void>;
export type Tab = 'ACTIVE' | 'ARCHIVE';

export default function Issues() {

    const path = window.location.pathname;
    const type = path.split('/')[2] === 'IT' ? 'IT' : 'EOS';
    const { user } = useUser();
    const [activeTab, setActiveTab] = useState<Tab>('ACTIVE');

    const key = `/issue-report?active=${activeTab === 'ACTIVE'}&type=${type}`;
    const {
        data,
        mutate
    } = useSWR(key, customFetcher<IssueReport>, {
        refreshInterval: 60000,
        fallbackData: []
    });

    const [selectedId, setSelectedId] = useState<number>();
    const { modal, setModal } = useModal();
    const issue = data.find(item => item.id === selectedId);

    const toggleTab = (tab: Tab) => {
        setModal(false);
        setActiveTab(tab);
    };

    const viewIssue = (id: number) => {
        setSelectedId(id);
        setModal(true);
    }

    const updateIssue: UpdateIssue = async (status: IssueReportStatus, note: string, notifyUser: boolean) => {
        try {
            const res = await apiClient.put(`/issue-report`, {
                id: issue.id,
                note,
                updateType: 'NOTE',
                type: issue.type,
                status,
                modifiedBy: user.s_email,
                modifiedAt: getTsDate(),
                notifyUser,
                createdBy: issue.createdBy
            });
            notify('Updated');
            mutate();
        } catch (err) {
            alert(err);
        }
    }

    const assign: AssignIssue = async (assignedTo: string) => {
        try {
            const res = await apiClient.put(`/issue-report`, {
                id: issue.id,
                note: `Assigned to ${assignedTo.toUpperCase()} by ${user.s_email}`,
                type: 'EVENT',
                assignedTo,
                modifiedBy: user.s_email,
                modifiedAt: getTsDate(),
                status: 'IN_PROGRESS',
                assign: assignedTo.toUpperCase() !== user.s_email
            });
            notify('Updated');
            mutate();
        } catch (err) {
            alert(err);
        }
    }

    return (
        <Layout>
            <h1>{type} Ladybug</h1>
            <Nav tabs className={'separator-tabs'}>
                <CustomNavItem<Tab>
                    tabName="Active"
                    tabId="ACTIVE"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
                <CustomNavItem<Tab>
                    tabName="Archive"
                    tabId="ARCHIVE"
                    activeTabId={activeTab}
                    toggleTab={toggleTab}
                />
            </Nav>
            <TabContent activeTab={activeTab} className={'mt-2'}>
                <CustomTabPane<Tab> tabId={'ACTIVE'}>
                    <DataTable 
                        data={data}
                        viewIssue={viewIssue}
                    />
                </CustomTabPane>
                <CustomTabPane<Tab>tabId={'ARCHIVE'}>
                    <DataTable 
                        data={data}
                        viewIssue={viewIssue}
                    />
                </CustomTabPane>
            </TabContent>
            <DetailsModal
                modal={modal}
                setModal={setModal}
                issue={issue}
                updateIssue={updateIssue}
                assign={assign}
            />
        </Layout>
    );
}